<template>
    <div class="optimize-actual-content">
        <h2 class="primary-color m-b-8" v-html="$t('dashboard.component.optimize_actual_speed')"></h2>
        <p class="m-b-16">
            <span v-html="$t('dashboard.component.actual_speed_description')"></span>
            <a class="a-link" href="" target="_blank">{{ $t('app.buttons.learn_more') }}</a>
        </p>
        <div class="d-flex justify-content-center">
            <div :class="[$prefixClass.card + '-stroke actual-speed-card', index == 0 ? 'm-r-24' : '']" v-for="(card, index) in cards" :key="index">
                <img class="m-b-12" :src="require('@/modules/dashboard/assets/'+card.image)" /><br>
                <div class="text-left">
                    <h5 class="m-b-4">{{ card.title }}</h5>
                    <span v-html="card.description"></span>
                </div>
            </div>
        </div>
        <div class="text-right">
            <a-button class="m-t-32" type="primary" @click="startOptimize">
                {{ $t('onboarding.choose_opt_method') }}
                <i class="m-l-8 fas fa-chevron-right"></i>
            </a-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "OptimizeContent",
    props: {
    },
    data() {
        return {
            cards: [
                {
                    image: 'optimize-image.svg',
                    title: this.$t('dashboard.component.optimize_image'),
                    description: this.$t('dashboard.component.optimize_image_description')
                },
                {
                    image: 'optimize-theme.png',
                    title: this.$t('dashboard.component.optimize_theme'),
                    description: this.$t('dashboard.component.optimize_theme_description')
                }
            ]
        }
    },
    methods: {
        startOptimize() {
            this.$emit('start-optimize')
        }
    }
}
</script>
<style lang="scss">
    .optimize-actual-content {
        width: 562px;
        margin: auto;
        .a-card-stroke {
            &.actual-speed-card {
                background-color: $primary-light;
                padding: 16px 16px 24px 16px;
                width: 270px;
            }
        }
    }
</style>
